module.exports = __webpack_public_path__ + "static/media/mudit_bapna.881288de.jpg";